module.exports = __webpack_public_path__ + "img/2.002d5b5e.svg";